/** Lee `exp` del JWT sin verificar firma (solo para decidir si renovar en el cliente). */
export function jwtExpiresAtMs(token: string): number | null {
  try {
    const part = token.split('.')[1];
    if (!part) return null;
    const json = atob(part.replace(/-/g, '+').replace(/_/g, '/'));
    const payload = JSON.parse(json) as { exp?: unknown };
    return typeof payload.exp === 'number' ? payload.exp * 1000 : null;
  } catch {
    return null;
  }
}

/** true si falta JWT o expira en menos de `skewMs` (default 2 min). */
export function jwtNeedsRefresh(token: string | null, skewMs = 120_000): boolean {
  if (!token) return true;
  const exp = jwtExpiresAtMs(token);
  if (exp == null) return true;
  return Date.now() >= exp - skewMs;
}
